import React, { useEffect, useState } from "react";
import { GetListId } from "../../utils/helpers";
import {API_BASE_URL, QBO_APP_BASE_URL} from "../../utils/constants";
import { DownOutlined } from "@ant-design/icons";
import {Spin } from "antd";
import axios, {  } from "axios";
import { useParams, Link, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import moment, {  } from "moment";
import {Form, Input, Button, AutoComplete} from "antd";
import {openNotification} from '../../utils/helpers';
import http from "../../api/client";

function QboAccountSettings({accountSettings, classAccounts, callBack, deposite}) {
  const params = useParams();
  let history = useHistory();
  const [responseText, setResponseText] = useState();
  const [optionsOfClassAccounts, setOptionsOfClassAccounts] = useState(classAccounts);
  const [optionsOfDepositeAccounts, setOptionsOfDepositeAccounts] = useState(deposite);
  const [saveIsLoading, setSaveIsLoading] = useState(false);
  const [manualSyncIsLoading, setManualSyncIsLoading] = useState(false);
  const [manualClassSyncIsLoading, setManualClassSyncIsLoading] = useState(false);
  const [isShowSpin, setIsShowSpin] = useState(false);

  console.log("deposite in invoice: ", deposite);

  useEffect(() => {
    setOptionsOfClassAccounts(classAccounts);
  }, [classAccounts]);

  useEffect(() => {
    setOptionsOfDepositeAccounts(deposite);
  }, [deposite]);

  const optionsSaleType = [
    { label: "Sales Invoice", value: "salesInvoice" },
    { label: "Sales Reciept", value: "salesReciept" },
  ];

  const [form] = Form.useForm();
  const onFinish = (values) => {
    setSaveIsLoading(true);
    values.comp_id = params.companyId;
   
    if (values.classType) {
      var classAccountListId = GetListId(
        optionsOfClassAccounts,
        values.classType
      );
      values.classAccount_ListId = classAccountListId;
    } else {
      values.classType = "";
      values.classAccount_ListId = "";
    }

    if (values.depositeAccount) {
      var depositeAccountListId = GetListId(
        optionsOfDepositeAccounts,
        values.depositeAccount
      );
      values.deposit_account_list_id = depositeAccountListId;
    } else {
      values.deposit_account = "";
      values.deposit_account_list_id = "";
    }

    if (!values.order_prefix) 
    

    http
      .post( "/api/qbo/saveAccountSettings", values)
      .then((res) => {
        setResponseText(res.data?.message);
        setSaveIsLoading(false);
        openNotification('topRight', 'Success!', res.data.message);
      })
      .catch((err) => {
        console.log("err in catch of insert into AccountSeetings", err);
        setSaveIsLoading(false);

        if(err.response ){
          if(err.response.status === 401 ){
            // console.log("unauthorized in welcome: ",err.response.data.message);
            openNotification(
              "topRight",
              "Unauthorized!",
              err.response.data.message,
              "error"
            );
            history.push("/unAuthorizedUser");
          }
        }


      });
  };

  function manualInvoiceSync(e) {
    e.preventDefault();
    setManualSyncIsLoading(true);
    http
      .get(
          "/api/qbo/manualInvoiceSyncing?companyId=" + 
          params.companyId
      )
      .then((res) => {
       
        setResponseText(res.data?.message);
        setManualSyncIsLoading(false);

        if(res.status === 200){
          openNotification('topRight', 'Orders synced successfully!', res.data?.message);
        
        }else if(res.status === 202){
          openNotification(
            "topRight",
            "Error!",
            res.data?.message,
            "error"
          );

        }else{
          openNotification(
            "topRight",
            "Error!",
            res.data?.message,
            "error"
          );
        }




      })
      .catch((err) => {
        console.log("err in catch of insert into AccountSeetings", err);
        setResponseText("err in catch of insert into AccountSeetings");
        setManualSyncIsLoading(false);

        if(err.response ){
          if(err.response.status === 401 ){
            // console.log("unauthorized in welcome: ",err.response.data.message);
            openNotification(
              "topRight",
              "Unauthorized!",
              err.response.data.message,
              "error"
            );
            history.push("/unAuthorizedUser");
          }
        }

      });
  }

  function manualClassesSync(e) {
    e.preventDefault();
    setManualClassSyncIsLoading(true);
    setIsShowSpin(true);
    
    var instance = axios.create();
    delete instance.defaults.headers.common['Authorization'];

     instance
      .post(
          QBO_APP_BASE_URL +
          "onboarding.php?companyId=" +
          params.companyId +
          "&onboardingType=class"
       )
      .then((res) => {
        const myArray = res.data.split("<body>");
        // console.log("myArray", JSON.parse(myArray[1]));
        if (myArray[1]) {
          openNotification('topRight', 'Classes synced successfully!', JSON.parse(myArray[1]).message);
        }
        callBack();
        setManualClassSyncIsLoading(false);
        setIsShowSpin(false);
      })
      .catch((err) => {
        console.log("err in catch of classes sync", err);
        setResponseText("err in catch of classes sync");
        setManualClassSyncIsLoading(false);
        setIsShowSpin(false);
      });
  }

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 8,
      },
    },
    wrapperCol: {
      xs: {
        span: 16,
      },
      sm: {
        span: 16,
      },
    },
  };

  return (
    <div className="font-raleway">
      {accountSettings && (
        <>
          <Form
            {...formItemLayout}
            form={form}
            name="register"
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              classType: accountSettings.companySettings.order_class,
              depositeAccount: accountSettings.companySettings.deposit_account,
              orderPrefix: accountSettings.companySettings.order_prefix,
            }}
            scrollToFirstError
          >
            
            <div className=" col-span-10 text-lg flex justify-start">
              <p>
               Create an <span className="font-bold">Invoice </span>in{" "}
                <span className="font-bold">QuickBooks Online</span>{" "}when an{" "}
                <span className="font-bold">Order </span> is placed on{" "}
                <span className="font-bold">Shopify.</span>
              </p>
            </div>
            <div className="w-full   grid grid-cols-12">
              <div className="w-full col-span-9 grid grid-cols-12 ">
               

                  {/* Assign to class */}
                <div className="pt-2 col-span-12 grid grid-cols-12">
                  <div className=" col-span-6 ">
                    <Form.Item
                    style={{textAlign: 'left'}}
                    label="Assign to Class:"
                      name="classType"
                      tooltip={{
                        title:
                          "Assign to Class ",
                        // icon: <InfoCircleOutlined />,
                      }}
                      rules={[
                       

                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (
                              !value ||
                              optionsOfClassAccounts.find(
                                (o) => o.value === getFieldValue("classType")
                              )
                            ) {
                              return Promise.resolve();
                            }

                            return Promise.reject(
                              new Error("Select Valid Class Account!")
                            );
                          },
                        }),
                      ]}
                    >
                      <AutoComplete
                        style={{
                          width: 360,
                        }}
                        options={optionsOfClassAccounts}
                    
                      >
                        <Input
                          value={"optionsOfClassAccounts"}
                          placeholder="Class Account"
                          suffix={
                           
                            <DownOutlined />
                          }
                        />
                      </AutoComplete>
                    </Form.Item>
                  </div>
                  <div className="col-span-6">
                  <div className="text-xs pl-2  w-full flex justify-start items-center h-full">
                      <div className="flex pt-1.5">
                        <div>Don't see all your classes? try</div>
                        <div className="flex justify-start">
                          <button
                            onClick={(e) => manualClassesSync(e)}
                            className="text-primary font-bold px-1"
                          >
                            Refresh
                          </button>
                        </div>
                      </div>
                      {isShowSpin && (
                        <div className="px-2">
                          <Spin />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                
                  {/* payment deposite */}
                <div className="   col-span-12 grid grid-cols-12 ">
                   
                  <div className=" col-span-7">
                    <Form.Item
                    style={{textAlign: 'left'}}
                      name="depositeAccount"
                      label="Payment deposits:"
                      tooltip={{
                        title:
                          "Payment deposits (QuickBooks account: Asset)",
                        // icon: <InfoCircleOutlined />,
                      }}
                      rules={[
                        
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (
                              !value ||
                              optionsOfDepositeAccounts.find(
                                (o) =>
                                  o.value === getFieldValue("depositeAccount")
                              )
                            ) {
                              return Promise.resolve();
                            }

                            return Promise.reject(
                              new Error("Select Valid Deposite Account!")
                            );
                          },
                        }),
                      ]}
                    >
                      <AutoComplete
                        style={{
                          width: 360,
                        }}
                        options={optionsOfDepositeAccounts}
                        
                        // filterOption={(inputValue, option) =>
                        //   option.value
                        //     .toUpperCase()
                        //     .indexOf(inputValue.toUpperCase()) !== -1
                        // }
                      >
                        <Input
                          value={"optionsOfDepositeAccounts"}
                          placeholder="Deposite Account"
                          suffix={
                            <DownOutlined />
                          }
                        />
                      </AutoComplete>
                    </Form.Item>
                  </div>
                </div>

                {/* order prefix */}
                <div className="  col-span-12 grid grid-cols-12">
                  
                  <div className=" col-span-7 ">
                    <Form.Item name="orderPrefix"
                    label="Order Number Prefix:"
                    tooltip={{
                      title:
                        "Order Number Prefix",
                      // icon: <InfoCircleOutlined />,
                    }}
                    >
                      <Input
                      style={{height:32 , textAlign:'left', paddingTop:4}}
                        placeholder="Order Prefix"
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>
              <div className="col-span-3">
                <img src={require("../../images/icons/product_left.png")} />
              </div>
            </div>




            {(accountSettings.companySettings.sync_type === 'manualSync' || accountSettings.companySettings.sync_type === 'both') && <div className="w-full border  mt-4 py-2 px-4 grid grid-cols-12">
            <div className="col-span-10 flex justify-start">
                <div className="text-left ">
                  <h1 className="  font-bold">Manual Sync:</h1>
                  <p className="  ">
                  Sync orders manually (Data Sync Limit: 2 Months Old)
                  </p>
                  <div className="">
                    <p className="  whitespace-pre ">
                      Manual Sync will sync existing orders starting
                      <span className="ml-1 font-bold">
                      {moment(accountSettings.companySettings.item_starting_date).format("MM-DD-YYYY").toString()}
                      </span>
                      . You can change the date range from  
                    </p>
                    <p className="whitespace-pre   -mt-3 -ml-1"> the <Link to={params.companyId + "/settings"}>Settings</Link> 
                    {" "}screen in the side menu{" "}
                        </p>
                  </div>
                </div>
              </div>
              <div className="col-span-2  grid content-end mb-4">
                <Button
                  loading={manualSyncIsLoading}
                  onClick={(e) => manualInvoiceSync(e)}
                  className="h-8 ml-4 px-2 border-2 outline-1 hover:bg-gray-300"
                >
                  <FontAwesomeIcon icon={faArrowsRotate} className="px-2" />
                  Manual Sync
                </Button>
              </div>
            </div>}

            <div className=" col-span-12 grid grid-cols-12 mt-4 mb-10">
              <div className="py-2 col-span-6  flex justify-start gap-4">
                <Button
                  loading={saveIsLoading}
                  className="  w-24"
                  type="primary"
                  htmlType="submit"
                
                >
                  Save
                </Button>

                <Button
                  loading={false}
                  className="  w-24"
                 
                  onClick={(e) => {
                    alert("Cancel Botton Clicked!");
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </Form>
        </>
      )}
    </div>
  );
}

export default QboAccountSettings;
